import { useState } from "react";
import { contactForm } from "../api";
export default function JoinUs() {
  const [formdata, setformdata] = useState({
    name: "",
    email: "",
    number: "",
    purpose: "",
    message: "",
  });

const heandleSubmit = async (event) => {
  event.preventDefault();

  try {
    const response = await contactForm(formdata);

    console.log(response.data);

    alert("Form submitted successfully");

    setformdata({
      name: "",
      email: "",
      number: "",
      purpose: "",
      message: "",
    });
  } catch (error) {
    console.error(error);
  }
};
  const handleChange = (e) => {
    setformdata({
      ...formdata,
      [e.target.name]: e.target.value,
    });
  };

  const purposes = [
    "Agritech: Smart Vertical Farms, Saffron, Golden Eggs",
    "Water & Energy: Bio-Energy, Solar, Zero Waste",
    "Eco Design: Smart Cities, Eco Ashrams",
    "Franchise Parks: Rapid ROI Models",
  ];
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Hero Section */}
      <section className="bg-slate-900 py-20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-6xl font-bold text-white">Join Us</h1>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Left Side */}
            <div>
              <span className="text-green-600 font-semibold text-xl">
                Get in touch
              </span>

              <h2 className="mt-4 text-5xl font-bold text-green-600 leading-tight">
                Let’s Build the Future Together
              </h2>

              <p className="mt-6 text-gray-700 text-lg">
                Whether you're an investor, entrepreneur, or future franchise
                owner—let’s connect.
              </p>

              <p className="mt-8 text-green-600 text-xl">
                Head Office: Oxford Street, Zirakpur, Punjab, India
              </p>

              <div className="flex flex-wrap gap-4 mt-12">
                <button   type="button" className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition">
                  Download Brochure
                </button>

                <button   type="button" className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition">
                  Start a Franchise Inquiry
                </button>
              </div>
            </div>

            {/* Right Side Form */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <form className="space-y-5" onSubmit={heandleSubmit}>
                <input
                  type="text"
                  placeholder="First Name"
                  name="name"
                  value={formdata.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                />

                <input
                  type="email"
                  placeholder="Email Address"
                  name="email"
                  value={formdata.email}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                />

                <input
                  type="tel"
                  placeholder="Number"
                  name="number"
                  value={formdata.number}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                />

                <select
                  className="w-full border border-gray-300 rounded-lg px-4 py-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                  name="purpose"
                  value={formdata.purpose}
                  onChange={handleChange}
                >
                  <option value="">Purpose</option>

                  {purposes.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>

                <textarea
                  rows="5"
                  placeholder="Your Message"
                  name="message"
                  value={formdata.message}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                ></textarea>

                <button
                  type="submit"
                  className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition w-full"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map */}
      <section className="pb-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="overflow-hidden rounded-2xl shadow-lg">
            <iframe
              title="Oxford Street Zirakpur"
              src="https://maps.google.com/maps?q=Oxford%20Street%20Zirakpur&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}
